const apis = {
    apiTip: 'Create an API key to meet your trading needs. To ensure asset security, do not disclose your API key.',
    cjapi: 'Create API',
    bzm: 'Remark',
    qx: 'Permissions',
    cjrq: 'Creation Date',
    cz: 'Actions',
    ck: 'View',
    bj: 'Edit',
    sc: 'Delete',
    mm: 'Passphrase',
    qsrmm: 'Please enter the passphrase',
    sjyzm: 'Mobile Verification Code',
    qsryzm: 'Please enter the verification code',
    yxyzm: 'Email Verification Code',
    dzbmd: 'IP Address Whitelist (optional)',
    my: 'Secret Key',
    cancel: 'Cancel',
    confirm: 'Confirm',
    fzapi: 'Copy API Info',
    qdsc: 'Do you want to delete the {name} API?',
    tip: 'Tip',
    sccg: 'Deleted successfully!',
    yqxsc: 'Deletion cancelled',
    tips: 'Note:',
    zdcy: 'Each main and sub-account can hold up to 50 active API keys.',
    qwxl: 'Do not disclose your API key; binding the API key to an IP can significantly improve security.',
    dsfbd: 'Binding an API with trading and withdrawal permissions to a third-party platform may result in API information leakage, please operate cautiously.',
    zdsc: 'For your fund security, an API key with trading or withdrawal permissions that is not bound to an IP address will be automatically deleted after 14 days of inactivity and will need to be reapplied. API keys bound to an IP or those with read-only permissions have no expiration.',
    dq: 'Read',
    jy: 'Trade',
    ljcj: 'Create Now',
    qsrbzm: 'Please enter the remark',
    cjcg: 'Created successfully',
    czapi: 'Reset API',
    cjlc: 'Click to create API key > Create your own API key and related info > View API documentation details > Develop and trade',
    zdbddz: 'Each API key can bind up to 20 IP addresses, separated by commas.',
    xgcg: 'Modified successfully',
  }
  export {
    apis
  }
  


// WEBPACK FOOTER //
// ./src/i18n/lang/api/en.js